import { getRuntimeLiffId } from "@utils/line/getLiffId";

/**
 * 家庭邀請碼相關連結組裝。
 *
 * QR / 分享連結會把對方帶到「新增帳戶 → 加入既有的瓦斯帳戶」流程，
 * 並自動帶入邀請碼（addAccount 讀取 `?invite_code=` query 後自動進入 join_code 並預填）。
 *
 * 此 App 是 LINE LIFF App，因此連結要用 **LIFF 連結**
 * `https://liff.line.me/{liffId}/account/addAccount?invite_code=...`，
 * 對方掃 QR / 點連結會直接在 LINE 內開啟並登入（而非在外部瀏覽器跑「繼續」登入流程）。
 * 無 LIFF id（例如本機未設）時 fallback 回網頁網域。
 */
const JOIN_PATH = "/account/addAccount";
const LIFF_BASE = "https://liff.line.me";

/** 取得目前部署的 origin；SSR / 測試環境 fallback 為空字串（相對路徑）。 */
const getOrigin = (): string =>
  typeof window !== "undefined" && window.location ? window.location.origin : "";

/** 對方掃 QR / 點連結加入家庭用的完整網址（優先 LIFF 連結）。 */
export const buildInviteJoinUrl = (inviteCode: string): string => {
  const code = encodeURIComponent(inviteCode);
  const liffId = getRuntimeLiffId();
  if (liffId) {
    // LIFF 會把 liffId 後面的路徑與 query 轉發到 endpoint URL，App router 再處理該路由。
    return `${LIFF_BASE}/${liffId}${JOIN_PATH}?invite_code=${code}`;
  }
  // fallback：拿不到 LIFF id 時退回網頁網域（至少可用）。
  return `${getOrigin()}${JOIN_PATH}?invite_code=${code}`;
};

/** 分享文案（LINE / 複製連結用）。 */
export const buildInviteShareText = (inviteCode: string, contextName?: string): string => {
  const target = contextName ? `「${contextName}」` : "我的瓦斯帳戶";
  return `邀請你一起管理${target}！\n邀請碼：${inviteCode}\n點此加入：${buildInviteJoinUrl(inviteCode)}`;
};
